import { breakpoints } from '@toggle/design-system';
import React, {
  createContext,
  FC,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';

const mediaQueriesValues = Object.values(breakpoints);
const mediaQueryLists =
  typeof window !== 'undefined'
    ? mediaQueriesValues.map(q => window.matchMedia(q))
    : [];

const getMediaQueryValue = () => {
  const index = mediaQueryLists.findIndex(mql => mql.matches);
  return mediaQueriesValues[index];
};

export const MediaQueryContext = createContext('');
export const useMediaQuery = () => useContext(MediaQueryContext);

export const useTouchDevice = () => {
  const currentMedia = useMediaQuery();
  return [breakpoints.xs, breakpoints.sm, breakpoints.md].includes(
    currentMedia
  );
};

export interface MediaQueryStoreProps {
  children: ReactNode;
}

export const MediaQueryStore: FC<MediaQueryStoreProps> = ({ children }) => {
  const [currentMedia, setCurrentMedia] = useState(getMediaQueryValue);

  useEffect(() => {
    const changeListener = () => {
      setCurrentMedia(getMediaQueryValue());
    };

    mediaQueryLists.forEach(media =>
      media.addEventListener('change', changeListener)
    );

    return () => {
      mediaQueryLists.forEach(media =>
        media.removeEventListener('change', changeListener)
      );
    };
  }, []);

  return (
    <MediaQueryContext.Provider value={currentMedia}>
      {children}
    </MediaQueryContext.Provider>
  );
};
